export const brandConfigObjectMap = new Map();

brandConfigObjectMap.set('blg-en', {
    pricePoint: 'Battle_League_Gaming',
    offerCode: '001050038359', // TODO: Used from onevas service in config
    networkId: 1000030062,
    gameUrl: 'https://www.esport.et',
    errorUrl: 'https://www.esport.et',
    redirectUrl: 'https://blg-play.esport.et/thank-you',
    platformUrl: 'https://www.esport.et',
    headerText: 'Play competitive gaming anytime, anywhere and climb the ranks!',
    subHeaderText: 'Subscribe now, and challenge your opponents with only 2 Birr/Day. Enjoy a 3-day free trial for your first Registration', // TODO: Need changes here
    errorText: 'An error has occurred, please click retry below.',
    gtmIdentifier: 'GTM-5FL66DKB',
    subscribeButton: 'SUBSCRIBE NOW',
    termsAndConditionsText: 'Terms and Conditions',
    unsubHelpText: 'To unsubscribe,send STOP to 8761.For help 0944878461',
    tabTitle: 'Battle League Gaming',
    productId: 1000030062,
    termsAndConditionsUrl: 'https://esport.et/terms-conditions',
    campaignId: 251114001,
    mcc: 422,
    mnc: 402,
    serviceId: 300047200007049,
    spId: 300049,
    landingPage: 'LandingPageBLG',
    battlegroundsLabel: 'All Our Battlegrounds',
});

brandConfigObjectMap.set('blg-am', {
    pricePoint: 'Battle_League_Gaming',
    offerCode: '001050038359', // TODO: Used from onevas service in config
    networkId: 1000030062,
    gameUrl: 'https://www.esport.et',
    errorUrl: 'https://www.esport.et',
    redirectUrl: 'https://blg-play.esport.et/thank-you',
    platformUrl: 'https://www.esport.et',
    headerText: 'ተወዳዳሪ ጨዋታዎችን በማንኛውም ጊዜ፣ በየትኛውም ቦታ ይጫወቱ፤ ደረጃዎንም ያሳድጉ!',
    subHeaderText: 'አሁኑኑ ይመዝገቡና በቀን 2 ብር ብቻ ተጋጣሚዎችዎን ይግጠሙ! ለመጀመሪያ ምዝገባዎ የ3 ቀን ነጻ ሙከራ ያግኙ።', // TODO: Need changes here
    errorText: 'An error has occurred, please click retry below.',
    gtmIdentifier: 'GTM-5FL66DKB',
    subscribeButton: 'አሁኑኑ ይመዝግቡ',
    unsubHelpText: 'ምዝገባ ለማቋረጥ \'STOP\' የሚለውን ወደ 8761 ይላኩ። ለእርዳታ 0944878461 ይደውሉ።',
    termsAndConditionsText: 'ደንቦች እና ሁኔታዎች',
    tabTitle: 'Battle League Gaming',
    productId: 1000030062,
    termsAndConditionsUrl: 'https://esport.et/terms-conditions',
    campaignId: 251114001,
    mcc: 422,
    mnc: 402,
    serviceId: 300047200007049,
    spId: 300049,
    landingPage: 'LandingPageBLG',
    battlegroundsLabel: 'ሁሉም የእኛ የውድድር መድረኮች',
});

brandConfigObjectMap.set('fantasy-soccer-en', {
    pricePoint: 'Fantasy_Sports',
    offerCode: '001050038360',
    gameUrl: 'https://ethiofantasy.com',  // TODO: CHANGE THESE
    errorUrl: 'https://ethiofantasy.com',
    platformUrl: 'https://ethiofantasy.com',
    redirectUrl: 'https://fantasy-play.esport.et/thank-you',
    headerText: 'Compete in top fantasy leagues, rise the ranks & claim glory!',
    subHeaderText: 'Subscribe to Fantasy Sports for /day on your Ethiotel Account. T&Cs Apply. First Day Free.',
    errorText: 'An error has occurred, please click retry below.',
    gtmIdentifier: 'GTM-WPX49JCX',
    subscribeButton: 'SUBSCRIBE',
    termsAndConditionsText: 'Terms and Conditions',
    tabTitle: 'Fantasy Sports',
    productId: 16,
    termsAndConditionsUrl: 'https://ke.fantasyfootball.one/terms-and-conditions',
    campaignId: 251114002,
    mcc: undefined, // Todo need this for football
    mnc: undefined,
    serviceId: undefined,
    spId: undefined,
    landingPage: 'LandingPageFantasy',
});

